module.exports = __webpack_public_path__ + "img/list.5e113868.svg";